
// Components/ChatContacts/components/EmptyState.jsx
import React from "react";
import { Box, Typography } from '@mui/material';

const EmptyState = ({ filterType, searchQuery }) => {
    return (
        <Box sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            color: '#aaa',
            flexDirection: 'column',
            textAlign: 'center',
            p: 2
        }}>
            <Typography variant="body2">
                {filterType === 'unread'
                    ? "No hay mensajes sin leer"
                    : searchQuery
                        ? "No se encontraron contactos"
                        : "No hay contactos disponibles"}
            </Typography>
        </Box>
    );
};

export default EmptyState;
